import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTheme } from "../../ThemeContext";

const FileTypeModal = ({ open, onClose, title, children, fullScreen = false }) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <Transition appear show={open} as={React.Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={`fixed inset-0 ${isDark ? "bg-black/70" : "bg-black/50"}`} />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className={`flex min-h-full items-center justify-center p-4 ${fullScreen ? '!p-0' : ''}`}>
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-150"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={`${fullScreen ? 'w-full h-full max-w-full rounded-none' : 'w-full max-w-6xl rounded-lg'} shadow-2xl ${
                  isDark ? "bg-gray-900 text-white" : "bg-white text-gray-900"
                }`}
              >
                {!fullScreen && (
                  <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-gray-700">
                    <Dialog.Title className="text-lg font-semibold truncate pr-3">{title || "File Viewer"}</Dialog.Title>
                    <button
                      type="button"
                      onClick={onClose}
                      className={`rounded px-2 py-1 text-sm ${
                        isDark ? "bg-gray-700 hover:bg-gray-600" : "bg-gray-200 hover:bg-gray-300"
                      }`}
                    >
                      Close
                    </button>
                  </div>
                )}
                {fullScreen && (
                  <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-gray-700">
                    <Dialog.Title className="text-lg font-semibold truncate pr-3">{title || "File Viewer"}</Dialog.Title>
                    <button
                      type="button"
                      onClick={onClose}
                      className={`rounded px-2 py-1 text-sm ${
                        isDark ? "bg-gray-700 hover:bg-gray-600" : "bg-gray-200 hover:bg-gray-300"
                      }`}
                    >
                      Close
                    </button>
                  </div>
                )}
                <div className={fullScreen ? 'h-[calc(100%-56px)]' : ''}>{children}</div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default FileTypeModal;

